.card {
  background: var(--bg-surface);
  border-radius: var(--radius-md);
  padding: var(--space-md);
  transition: all var(--transition-base);
  position: relative;
  overflow: hidden;
}

.hoverable {
  cursor: pointer;
}

.hoverable::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, transparent, var(--accent-cyan), transparent);
  transform: translateX(-100%);
  transition: transform 0.4s ease;
}

.hoverable:hover::after {
  transform: translateX(100%);
}

.hoverable:hover {
  background: var(--bg-elevated);
  box-shadow: 0 0 20px var(--glow-cyan);
}

.default {
  border: 1px solid var(--border);
}

.glow {
  border: 1px solid var(--border-accent);
  box-shadow: 0 0 15px var(--glow-cyan);
}

.bordered {
  border: 1px solid var(--accent-cyan);
  background: linear-gradient(135deg, var(--bg-surface), var(--bg-elevated));
}
